import { api } from 'services/DefaultService';
import { IContactIdPossibleEventServiceProps } from './types';

const ENDPOINT = 'v1/contactIdPossibleEvent';

export const getAllContactIdPossibleEventsByLicense = async (): Promise<
  IContactIdPossibleEventServiceProps[]
> => {
  try {
    const response = await api.get<IContactIdPossibleEventServiceProps[]>(
      ENDPOINT + '/getAllByLicense',
    );
    return response.data;
  } catch (error: any) {
    throw new Error('Unable to get all contactIdPossibleEventsByLicense');
  }
};
